module.exports = __webpack_public_path__ + "img/54.9457af40.jpg";